import PropTypes from "prop-types";
import './Menu.scss';
import Dish from "./dish/Dish";

const Menu = ({options}) => {
    const hasDishes = options && options.length > 0;
    return hasDishes && (
        <div className="menu">
            <p className="menu--title">Lunch menu</p>
            {options.map((item, index) => (
                <Dish
                    key={index}
                    dish={item}
                />
            ))}
        </div>
    );
};

Menu.propTypes = {
    options: PropTypes.array
}

export default Menu;